import { baseWhite, inkLight, secondaryBase } from '../../../../styles/design-tokens';
import { Button } from '../../../../ui-library/button/button';
import { Icon } from '../../../../ui-library/icon/icon';
import { ChartType } from '../../process-analysis.type';

type Props = {
  chartType: ChartType;
  isActive: boolean;
  onClick: () => void;
};

export const ChartTypeToggleButton = ({ chartType, isActive, onClick }: Props) => {
  const getIconName = () => {
    switch (chartType) {
      case ChartType.Line:
        return 'stacked_line_chart';
      case ChartType.Bar:
        return 'bar_chart';
      default:
        return 'stacked_line_chart';
    }
  };

  return (
    <Button
      variant={isActive ? 'primary' : 'outline'}
      radius="xl"
      size="xs"
      onClick={onClick}
      style={{
        padding: '8px 16px',
        backgroundColor: isActive ? secondaryBase : 'transparent',
      }}
    >
      <Icon name={getIconName()} size={14} color={isActive ? baseWhite : inkLight} pointer />
    </Button>
  );
};
